export default "__VITE_ASSET__BTzemcej__"